export const numberOfDays = 7;
